// extracted by mini-css-extract-plugin
export var cardContainer = "_pn-0";
export var cardHeader = "_pn-2";
export var collapsedState = "_pn-3";
export var dragHandle = "_pn-5";
export var dragHandleIcon = "_pn-6";
export var dragging = "_pn-1";
export var titleArea = "_pn-4";